import { useLocation, Link } from 'react-router-dom';

const Breadcrumb = ({ segments = [], paths = [] }) => {
	const location = useLocation();
	const pathname = location.pathname;

	if (segments.length === 0) segments = pathname.split('/');

	return (
		<div className="flex items-center ml-5 mt-5 md:ml-[84px] md:mt-[48px]">
			{segments.map((segment, index) =>
				<div key={index} className="flex items-center">
					<Link
						to={paths[index] || segments.slice(0, index + 1).join('/')}
						className="text-black font-semibold text-{13px} hover:underline underline-offset-4 hover:last:no-underline last:cursor-default mr-2"
					>
						{segment}
					</Link>
					{index !== segments.length - 1 && (
						<p className="mr-2 inline-block text-black font-semibold text-{13px}">
							{'>'}
						</p>
					)}
				</div>
			)}
		</div>
	);
}

export default Breadcrumb;
